import type { IMessageShape } from './message';
import { messageSchema } from './message';
import { actionCreator, Joi, objectSchemaOf } from '../helpers';
import { DIALOGUE_INPUT } from './topics';
import { forConversation } from '../channels';

export const NEW_MESSAGE = 'DIALOGUE/NEW_MESSAGE' as const;

export const newMessageActionSchema = objectSchemaOf<INewMessageAction>({
  type: Joi.string().required().valid(NEW_MESSAGE),
  payload: messageSchema.required(),
});

export interface INewMessageAction {
  type: typeof NEW_MESSAGE;
  payload: IMessageShape;
}

export const newMessage = actionCreator({
  type: NEW_MESSAGE,
  schema: newMessageActionSchema,
  topic: DIALOGUE_INPUT,
  channels: [forConversation],
});
